import React from 'react';
import { useSelector } from 'react-redux';
import './BangoBackButton.css';

const BangoBackButton = () => {
  const { redirectUrl } = useSelector((s) => s.integrations.bango);
  const text = 'Back to Verizon +Play';
  if (!redirectUrl) return null;
  return (
    <a href={redirectUrl} className="bangoBackButton">
      <img className="bangoBackIcon" src="/account/static/images/arrow-back-white.svg" alt="back-arrow" />
      {text}
    </a>
  );
};
export default BangoBackButton;
